var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }
import * as React from "react";
function SvgArrowFp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1080 1080",
    style: {
      enableBackground: "new 0 0 1080 1080"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E60000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M435.56,234.55L583.11,519.2c7.22,13.8,8.7,37.06,0,53.84L435.56,857.69 c-20.69,39.92-9.34,85.85,43.76,68.45l489.89-351.7c41.36-28.85,44.45-48.96,0-83.05L479.32,166.1 C447.4,143.74,394.77,155.67,435.56,234.55z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M122.65,158.21c-18.86,0-27.23,13.72-18.6,30.49L272,515.1c8.63,16.77,8.63,44.22,0,60.99L104.05,902.48 c-8.63,16.77-0.26,30.49,18.6,30.49h177.37c18.86,0,41.36-13.72,49.99-30.49l167.95-326.39c8.63-16.77,8.63-44.22,0-60.99 L350.01,188.71c-8.63-16.77-31.12-30.49-49.99-30.49H122.65z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFp);
export default __webpack_public_path__ + "static/media/arrow_fp.c5d2740e313e4d24621a5a6d4c657b71.svg";
export { ForwardRef as ReactComponent };